import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var UpploadService = function UpploadService() {
  _classCallCheck(this, UpploadService);

  this.type = "service";
  this.name = "";
  this.invisible = false;
  this.noRecolor = false;
  this.icon = "";
  this.color = "#333";

  this.template = function () {
    return "";
  };

  this.handlers = function () {};

  this.stop = function () {};

  this.supports = function () {
    return true;
  };
};